import { dropDownOptions, IEndorsementType } from "./DAO";
import { LineOfBusinessTypes } from "./Endorsements/AdditionalInsured.Model";
import { EndorsementTypes } from "./Endorsements/Endorsement.Model";

export class Constants {
  public static FleetSizeOptions: Array<dropDownOptions> = [
    { label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" },
    { label: "4", value: "4" }, { label: "5", value: "5" }, { label: "6", value: "6" },
    { label: "7", value: "7" }, { label: "8", value: "8" }, { label: "9", value: "9" },
    { label: "10", value: "10" }, { label: "11", value: "11" }, { label: "12", value: "12" },
    { label: "13", value: "13" }, { label: "14", value: "14" }
  ];
  public static BannerTypes: Array<dropDownOptions> = [
    { label: "Major/Critical", value: "critical" },
    { label: "Warning", value: "warning" },
    { label: "Informational", value: "info" }
  ];

  public static EndorsementTypes: Array<IEndorsementType> = [
    { label: "Add Driver", value: EndorsementTypes.AddDriver, group: "Driver" },
    { label: "Delete Driver", value: EndorsementTypes.DeleteDriver, group: "Driver" },
    { label: "Add Vehicle", value: EndorsementTypes.AddVehicle, group: "Vehicle" },
    { label: "Delete Vehicle", value: EndorsementTypes.DeleteVehicle, group: "Vehicle" },
    { label: "Add Additional Insured", value: EndorsementTypes.AddAdditionalInsured, group: "Additional Insured" },
    { label: "Delete Additional Insured", value: EndorsementTypes.DeleteAdditionalInsured, group: "Additional Insured" },
    { label: "Loss Run Request", value: EndorsementTypes.LossRun, group: "Loss Run Request" },
    { label: "Other", value: EndorsementTypes.otherEndorsements, group: "Others" }
  ];

  public static EndorsementStatusDropDrown: Array<dropDownOptions> = [
    { label: "Submitted", value: "Submitted" },
    { label: "Incomplete", value: "Incomplete" }
  ];

  public static EndorsementBaseRoute: string = '/endorsements/';

  public static VehicleTypesDropDown: Array<dropDownOptions> = [
    { label: "Power Unit", value: "Power Unit" },
    { label: "Trailer", value: "Trailer" }
  ]

  public static InterestTypesDropDown: Array<dropDownOptions> = [
    { label: "Additional Insured", value: "Additional Insured" },
    { label: "Loss Payee", value: "Loss Payee" }
  ]
  
  public static ClearanceStatus: Array<string> =
    ["Additional Info Needed", "Quoted", "Close Quote", "Declined", "Decline Override"];

  public static InternalAdminUserActions: Array<dropDownOptions> = [
    { label: "Update Banner", value: "updateBanner" }
  ];
  public static FileNetAllowedFileExtensions: Array<string> = [
    '.mp3', '.mp4', '.wma', '.rar', '.zip', '.msg', '.eml', '.tiff', '.tif', '.jpg', '.jpeg', '.gif', '.png', '.bmp', '.psd', '.ai', '.svg', '.doc', '.dot', '.docx',
    '.dotx', '.docm', '.dotm', '.rtf', '.txt', '.xls', '.xlsx', '.xlsm', '.csv', '.one', '.ppt', '.pps', '.pptx', '.pptm', '.ppsx', '.ppsm', '.mpp', '.vsd', '.vsdx',
    '.vsdm', '.pdf', '.avi', '.mov', '.wmv', '.vcf', '.htm', '.html', '.xhtml', '.mhtml', '.mht', '.xml'
  ];
  public static readonly CurrentDriverExcelTemplateVersion: string = '1.0';
  public static readonly CurrentVehicleExcelTemplateVersion: string = '1.1';

  public static LineOfBusinessOptions: Array<dropDownOptions> = [
    { label: "Commercial Auto", value: LineOfBusinessTypes.CommercialAuto },
    { label: "General Liability", value: LineOfBusinessTypes.GeneralLiability }
  ];

  public static VehicleType: Array<dropDownOptions> = [
    { label: "Power Unit", value: "PowerUnit" },
    { label: "Trailer", value: "Trailer" }
  ];
  public static readonly SAVE_AND_SUBMIT_CLICKED: string = "saveAndSubmitClicked";
  public static readonly SAVE_AND_CONTINUE_COMPLETED: string = "saveAndContinueCompleted";
  public static readonly SUBMISSION_DECLINED: string = "submissionDeclined";
  public static readonly SUBMISSION_CANCELLED: string = "submissionCancelled";
  public static readonly CLEAR_MY_AGENCY: string = 'ClearMyAgency';
  public static readonly REQUEST_QUOTE: string = 'RequestQuote';
  public static readonly ONLY_ALPHABETICALS_ARE_ALLOWED: string = 'Only alphabetical characters are allowed. Please correct the data before proceeding further.'
  public static readonly PLS_UPDATE_FIELDS_IN_RED = 'Please update the fields highlighted in red.';
  public static readonly INDICATION_ENABLED_STATES = ["OH", "GA", "IL", "MS", "NV", "OK", "UT", "ID", "ND", "TX", "NC", "FL", "IN", "MO", "MN", "TN", "SC", "AZ", "IA", "WI", "NM", "DE", "SD", "WV", "RI", "AL", "MD", "AR", "KS", "OR", "CO", "LA", "NE", "KY", "ME", "NH", "MI"];
  public static readonly TestUserEmails: ReadonlyArray<string> = [
    'meera.augustine12@gmail.com',
    'vpadmanabhapillai@berkleysmallbusiness.com'
  ]
   
}

